export const TOKEN_BALANCE = {
  holding: 0,
  frozen: 0,
  interest: 0,
  pendingShortQty: 0,
  pendingExposure: 0,
  pendingLongQty: 0,
  pendingLongExposure: 0,
  staked: 0,
  unbonding: 0,
  vault: 0,
  averageOpenPrice: 0.0,
  pnl24H: 0,
  fee24H: 0,
  markPrice: null
}
